import { version } from 'react';

import { deviceInformation, baseUrl } from './getConfigFromBackend';

export const getCurrentRelease = () => {
    // retrieve branch name from baseUrl
    let release = version;
    if (deviceInformation.environment === 'development') {
        release = 'development';
    } else if (deviceInformation.environment === 'testing') {
        const matches = (baseUrl ? baseUrl : '')
            .split('//')
            .filter(function (v) {
                return v.indexOf('.') > -1;
            })
            .map(function (value) {
                return value.split('.')[0];
            });
        if (matches[0]) {
            release = `branch_${matches[0]}`;
        }
    }

    return release;
};
